import { useContext } from 'react';
import PropTypes from 'prop-types';
import { FiSend } from 'react-icons/fi';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import LoaderContext from '../../../../context/LoaderProvider';
import useToast from '../../../../hooks/useToast';
import { rectifyALine, sendToApproveLines } from '../../../../services/workReport';
import { workReportLineStatus } from '../../../../utils/dataStatus';
import ConditionalWrapper from '../../../ConditionalWrapper/ConditionalWrapper';
import { LineToAPpprove } from '../../../../utils/globalPropTypes';
import {
  rectifyAMonthlyLine,
  sendToApproveMonthlyLines
} from '../../../../services/monthlyServiceRequest';

const SendToApproveButton = (props) => {
  const {
    line,
    setChangeInLines,
    changeInLines,
    newFetch,
    setNewFetch,
    selectedDate,
    disabled,
    workReportId,
    monthly
  } = props;

  const selectedDateFormated = new Date(line?.fecha || selectedDate);
  const today = new Date();
  const todayOlderThanSelectedDate = today < selectedDateFormated;
  const { setNewToast } = useToast();

  const { id } = useParams();

  const { setLoader } = useContext(LoaderContext);

  const fetchToRectifyALine = async () => {
    setLoader(true);
    try {
      let resp;
      const body = {
        id: line.idParteDiario,
        cantidad: Number(line.cantidad)
      };

      if (monthly) {
        resp = await rectifyAMonthlyLine(id, body);
      } else {
        resp = await rectifyALine(body);
      }

      setChangeInLines(!changeInLines);
      setNewFetch(!newFetch);
      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message: resp.mensaje
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const fetchToApproveALine = async (lineToApprove) => {
    setLoader(true);
    try {
      let resp;

      if (monthly) {
        resp = await sendToApproveMonthlyLines(id, lineToApprove);
      } else {
        resp = await sendToApproveLines(workReportId, lineToApprove);
      }

      setChangeInLines(!changeInLines);
      setNewFetch(!newFetch);
      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message: resp.mensaje
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.mensaje
      });
    }
  };

  return (
    <ConditionalWrapper
      condition={todayOlderThanSelectedDate || line?.blockedBySap}
      wrapper={(children) => (
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={
            <Tooltip id="send-to-approve-request-detail">
              {line?.blockedBySap ? 'Inactiva por SAP' : 'Linea con fecha posterior a la actual'}
            </Tooltip>
          }
          placement="top"
        >
          {children}
        </OverlayTrigger>
      )}
    >
      <div className="p-1">
        <button
          aria-label="Enviar a aprobar"
          className="button_send_work_report"
          disabled={disabled || todayOlderThanSelectedDate}
          onClick={() => {
            if (line.estadoEnum === workReportLineStatus.enviar) {
              fetchToRectifyALine();
            } else {
              fetchToApproveALine([
                {
                  id: line.idParteDiario,
                  cantidad: Number(line.cantidad)
                }
              ]);
            }
          }}
          type="button"
        >
          <FiSend />
        </button>
      </div>
    </ConditionalWrapper>
  );
};

SendToApproveButton.propTypes = {
  workReportId: PropTypes.number.isRequired,
  line: LineToAPpprove.isRequired,
  selectedDate: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  setChangeInLines: PropTypes.func.isRequired,
  changeInLines: PropTypes.bool.isRequired,
  setNewFetch: PropTypes.func.isRequired,
  newFetch: PropTypes.bool.isRequired,
  monthly: PropTypes.bool
};

SendToApproveButton.defaultProps = {
  monthly: false
};

export default SendToApproveButton;
